import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

function Login() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setError('');
            setLoading(true);
            await login(email, password);
            navigate('/');
        } catch (err) {
            setError(t('auth_failed_signin') + err.message);
        }
        setLoading(false);
    }

    return (
        <div className="page-section">
            <div className="auth-container">
                <h2 className="section-title">{t('auth_login_title')}</h2>

                {error && <div className="error-banner">{error}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="email">{t('auth_email')}</label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">{t('auth_password')}</label>
                        <input
                            type="password"
                            id="password"
                            className="form-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn-primary-modern"
                        disabled={loading}
                    >
                        {loading ? t('auth_signing_in') : t('auth_login_title')}
                    </button>
                </form>

                <p className="auth-link forgot-password-link">
                    <Link to="/forgot-password">{t('auth_forgot_password')}</Link>
                </p>

                <p className="auth-link">
                    {t('auth_dont_have_account')} <Link to="/signup">{t('auth_signup_link')}</Link>
                </p>
            </div>
        </div>
    );
}

export default Login;
